import { Component, OnInit, inject } from '@angular/core';

import { ApContentService } from '@ap/content';

import content from './conversational-chat-connectionerror.content.json';

@Component({
    selector: 'conversational-chat-connectionerror',
    templateUrl: './conversational-chat-connectionerror.component.html',
    standalone: false
})
export class ConversationalChatConnectionerrorComponent implements OnInit {
    private readonly contentService = inject(ApContentService);

    public ngOnInit(): void {
        this.contentService.addContentItems(content);
    }
}
